import { useCallback } from 'react';
import { store } from 'redux/store';
import {
  resetCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';

export default function useClearSelection() {
  const clearSelection = useCallback(() => {
    store.dispatch(resetCP());
  }, []);

  return clearSelection;
}
